<template>
  <el-dialog
    title="外部頻道訂閱"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字">
              <el-input
                v-model="queryForm.qstr"
                placeholder="名稱"
                size="small"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div>
          <!--remove batch operation for now-->
          <!--<el-button-->
            <!--type="primary"-->
            <!--@click="handleBatchJoin"-->
            <!--size="small"-->
            <!--:disabled="selectedRow.length === 0" >批次訂閱</el-button >-->

          <!--<el-button-->
            <!--type="danger"-->
            <!--@click="handleBatchQuit"-->
            <!--size="small"-->
            <!--:disabled="selectedRow.length === 0" >批次退訂</el-button >-->
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 單位：{{ orgName }} ：可訂閱頻道
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            v-loading="isLoading"
            ref="dataTable"
            @selection-change="handleSelectionChange"
            :data="channels"
            @sort-change="sortChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            stripe
            style="width: 100%"
          >

            <!--remove batch operation for now-->
            <!--<el-table-column type="selection" width="45"> </el-table-column>-->

            <el-table-column
              prop="id"
              type="index"
              :index="indexFormatter"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="外部頻道名稱"
              prop="name"
              sortable="custom"
              width="250"
            >
              <template #default="scope">
              <el-tag :style="getTagStyle(scope.row.color)">{{scope.row.name}}</el-tag>
              </template>
            </el-table-column>

            <el-table-column
              label="來源單位"
              prop="orgName"
              width="160"
            >
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.organization.color)">{{ scope.row.organization.name }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="已訂閱" width="200" >
              <template #default="scope">
                <i v-if="isSubscribed(scope.row)" class="el-icon-check"></i>
                <i v-else class="el-icon-close"></i>
                {{ isSubscribed(scope.row) ? "是" : "否" }}
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template #default="scope">
                <el-button
                  v-if="isSubscribed(scope.row)"
                  type="danger"
                  @click="
                    isSubscr =>
                      changeSubscription(false, scope.row, scope.$index)
                  "
                  size="small"
                  :disabled="isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                >
                  退訂
                </el-button>
                <el-button
                  v-else
                  type="primary"
                  @click="
                    isSubscr =>
                      changeSubscription(true, scope.row, scope.$index)
                  "
                  size="small"
                  :disabled="isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                >
                  訂閱
                </el-button>

                <!--<el-switch-->
                <!--:value="isSubscribed(scope.row)"-->
                <!--active-text="是"-->
                <!--inactive-text="否"-->
                <!--:disabled="isSwitchDisabled(scope.$index)"-->
                <!--v-loading="isSwitchDisabled(scope.$index)"-->
                <!--@change="-->
                <!--isSubscr =>-->
                <!--changeSubscription(isSubscr, scope.row, scope.$index)-->
                <!--" >-->
                <!--</el-switch>-->
              </template>
            </el-table-column>
          </el-table>
        </CRow>

        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
      </CCardBody>
    </CCard>

    <AddExtChnlDlg
      v-model="isDlgVisible"
      :selectedChnl="selectedChnl"
      :key="`chnlDlg_${dlgKey}`"
      @subscribed="subsCallback"
    ></AddExtChnlDlg>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from "@/api/";
import { mapGetters } from "vuex";
import AddExtChnlDlg from "@/components/org/AddExtChnlDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  mixins: [tagColorsMixin],
  components: {
    AddExtChnlDlg,
  },
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orgName: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      channels: [],
      total: 0,
      offset: 0,
      sort: "id",
      order: "ascending",

      defaultSortCol: "id",
      defaultOrder: 'ascending',
      subsCallback: () => {},
      selectedChnl: {},
      isDlgVisible: false,
      dlgKey: 0,
      disabledSwitchIdx: [],
      selectedRow: [],
      pageSize: 50,
      formLabelWidth: "100px",
      isLoading: false,
      currentPage: 1,
      queryForm: {
        qstr: "",
      },
      activeQueryForm: {
        qstr: "",
      },
    };
  },
  created() {
    this.sort = this.defaultSortCol;
    this.order = this.defaultOrder;
    if (this.innerVisible) {
      //NOTE: always start from the first page
      this.query(this.pageSize, 0, this.sort, this.order);
    }
  },
  methods: {
    isSwitchDisabled(idx) {
      return this.disabledSwitchIdx.includes(idx);
    },

    batchHandler(isSkipped, actionFunc, successMsg) {
      let promises = [];
      this.isLoading = true;
      let runningItem = [];
      let failedItem = [];
      this.selectedRow.forEach(row => {
        if (!isSkipped(row)) {
          runningItem.push(row);
          promises.push(actionFunc(row, null, false, false));
        }
      });

      Promise.allSettled(promises)
        .then(results => {
          results.forEach((res, idx) => {
            //if (res.status === "fulfilled") {
            //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], false);
            //}
            if (res.status === "rejected") {
              //console.log(`rejected: pushed name = ${runningItem[idx].name}`);
              failedItem.push(runningItem[idx].name);
              //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], true);
            }
          });

          //console.log(`failedItem = ${JSON.stringify(failedItem)}`);
          if (!failedItem.length) {
            this.$message.success(successMsg);
          } else {
            this.$message.error("部分項目發生錯誤!");
          }
        })
        .finally(() => {
          this.query(
            this.pageSize,
            this.offset,
            this.sort,
            this.order,
            this.activeQueryForm
          ).then(() => {
            failedItem.forEach(failedName => {
              const failedOne = this.channels.find(
                item => item.name === failedName
              );
              failedOne &&
                this.$refs.dataTable.toggleRowSelection(failedOne, true);
            });
            //NOTE: we intentionally set loading to false ONLY when query succeeds
            this.isLoading = false;
          });
        });
    },

    handleBatchJoin() {
      const isSkipped = row => (this.isSubscribed(row) ? true : false);
      this.batchHandler(isSkipped, this.subsChnl.bind(this), "批次訂閱成功");
    },
    handleBatchQuit() {
      const isSkipped = row => (!this.isSubscribed(row) ? true : false);
      this.batchHandler(isSkipped, this.unsubsChnl.bind(this), "批次退訂成功");
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },

    changeSubscription(isSubscr, chnl, index) {
      const isChecked = this.selectedRow.find(row => row.name === chnl.name);
      let p;
      this.disabledSwitchIdx.push(index);
      if (isSubscr) {
        //p = this.subsChnl(chnl, index);
        p = this.subsSingleChnl(chnl, index);
      } else {
        p = this.unsubsChnl(chnl, index);
      }
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.channels[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    subsSingleChnl(chnl, index) {
      this.selectedChnl = chnl;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
      return new Promise(resolved => {
        this.subsCallback = res => {
          if (res.isSubs) {
            this.channels[index].children = [{ id: res.childId }];

            this.$message({
              type: "success",
              message: "訂閱成功!",
            });

            resolved(true);
          }
          resolved(false);
        };
      });
    },

    subsChnl(chnl, index, updateStore = true, showMsg = true) {
      const params = {};
      params.name = chnl.name;
      params.isPublic = true;
      params.color = chnl.color;
      params.parentId = chnl.id;
      params.enableAssign = false;

      return API.channel.add(params).then(res => {
        if (updateStore) {
          this.channels[index].children = [{ id: res.data.id }];
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "訂閱成功!",
          });
      });
    },

    unsubsChnl(chnl, index, updateStore = true, showMsg = true) {
      return API.channel
        .remove(chnl.children[0].id)
        .then(() => {
          if (updateStore) {
            this.channels[index].children = [];
          }

          showMsg &&
            this.$message({
              type: "success",
              message: "退訂成功!",
            });
        });
    },

    isSubscribed(chnl) {
      return chnl.children.length > 0 ? true : false;
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      const newParams = {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      };
      return API.channel
        .listExtChnl(newParams)
        .then(res => {
          if (res.status === 200) {
            this.channels = res.data[0];
            this.total = res.data[1];
            this.offset = offset;
            return res;
          } else {
            return Promise.reject(res);
          }
        })
        .finally(() => {
          this.disabledSwitchIdx = [];
        });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },

    sortChange(args) {
      if (args.order === null) {
        this.sort = this.defaultSortCol;
        this.order = this.defaultOrder;
      } else {
        this.sort = args.prop;
        this.order = args.order;
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    handleDlgClose() {
      const max = this.$store.getters["channel/max"];
      const offset = this.$store.getters["channel/offset"];
      const sort = this.$store.getters["channel/sort"];
      const order = this.$store.getters["channel/order"];
      this.$store.dispatch("channel/list", {
        scope: "external",
        max,
        offset,
        sort,
        order,
      });
    },
  },
};
</script>

<style></style>
